export enum ActionPermissionType {
  CHAT_SEND_FILES_TO_VISITOR,
  LENS_ENABLED,
  PINVITE_ENABLED,
  RC_ENABLED,
  RC_RECORDINGS_ALL,
  RC_RECORDINGS_OWN,
  ASSISTED_BROWSING_ACTION,
  ASSISTED_BROWSING_ENABLED,
  CHAT_GRID_VIEW_ACTIVE,
  CHAT_GRID_VIEW_MY_ACTIVE,
  CHAT_GRID_VIEW_INACTIVE,
  CHAT_GRID_VIEW_MY_INACTIVE,
  CHAT_GRID_COLUMN_CHOOSER,
  CHAT_ASSIGN_OTHER,
  CHAT_END_OTHER,
  CHAT_SUGGEST_ARTICLE,
  CHAT_DISCUSSION,
  CHAT_JOIN,
  CHAT_BLOCK_IP,
  CHAT_FLAG,
  CHAT_UNFLAG,
  EMAIL_DISCUSSION,
  EMAIL_ASSIGN_OTHER,
  EMAIL_CLOSE_OTHER,
  EMAIL_COLUMN_CHOOSER,
  TEXT_CHAT_GRID_VIEW_ACTIVE,
  TEXT_CHAT_GRID_VIEW_MY_ACTIVE,
  TEXT_CHAT_GRID_VIEW_INACTIVE,
  TEXT_CHAT_ASSIGN_OTHER,
  TEXT_CHAT_END_OTHER,
  TEXT_CHAT_COLUMN_CHOOSER,
  CHAT_WRAP_UP_EDIT_OWN,
  CHAT_WRAP_UP_EDIT_OTHER,
  CHAT_AGENT_STATS,
  CHAT_SHOW_OTHERS_POST_CHAT_SURVEY
}

/** This namespace gets exported, but idea can use the default enum values. It extends the primitive enum function
 * provided by typescript with these additional functions, like create array of enum's names and indices.
 * */
export namespace ActionPermissionType {
  function isIndex(key): boolean {
    const n = Math.floor(Number(key));
    return String(n) === key && n >= 0;
  }

  const _names: string[] = Object
    .keys(ActionPermissionType)
    .filter(key => !isIndex(key));

  const _indices: number[] = Object
    .keys(ActionPermissionType)
    .filter(key => isIndex(key))
    .map(index => Number(index));

  /**
   * Returns all keys as a (string[]) from the Enum
   */
  export function names(): string[] {
    return _names;
  }

  /**
   * Returns all indices as a (string[]) from the Enum
   */
  export function indices(): number[] {
    return _indices;
  }
}
